var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40263_68812)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 6,
    width: 49,
    height: 49,
    rx: 10,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.316 30.5H41.6085V34.7054L45.3377 36.8082L44.1914 38.7469L39.316 36.0029V30.5ZM40.8443 27.5173C38.8176 27.5173 36.8739 28.3029 35.4408 29.7013C34.0076 31.0997 33.2025 32.9963 33.2025 34.9739C33.2025 36.9515 34.0076 38.8481 35.4408 40.2464C36.8739 41.6448 38.8176 42.4304 40.8443 42.4304C42.871 42.4304 44.8148 41.6448 46.2479 40.2464C47.681 38.8481 48.4861 36.9515 48.4861 34.9739C48.4861 32.9963 47.681 31.0997 46.2479 29.7013C44.8148 28.3029 42.871 27.5173 40.8443 27.5173ZM40.8443 24.5347C43.6817 24.5347 46.4029 25.6346 48.4093 27.5923C50.4156 29.55 51.5428 32.2052 51.5428 34.9739C51.5428 37.7425 50.4156 40.3977 48.4093 42.3554C46.4029 44.3132 43.6817 45.413 40.8443 45.413C36.5802 45.413 32.8969 42.9673 31.1698 39.4478H16.3906V34.9739C16.3906 31.007 24.5368 29.0087 28.6175 29.0087C29.5345 29.0087 30.6655 29.113 31.8576 29.3069C32.827 27.8416 34.1576 26.6369 35.7276 25.8032C37.2976 24.9695 39.0569 24.5333 40.8443 24.5347ZM30.1458 34.9739C30.1458 33.93 30.2987 32.9159 30.589 31.9913C29.9471 31.8869 29.2747 31.8421 28.6175 31.8421C24.0783 31.8421 19.2945 34.0194 19.2945 34.9739V36.6143H30.2834C30.1914 36.0721 30.1454 35.5234 30.1458 34.9739ZM28.6175 15.5869C30.2388 15.5869 31.7938 16.2154 32.9403 17.3341C34.0868 18.4528 34.7309 19.9701 34.7309 21.5521C34.7309 23.1342 34.0868 24.6515 32.9403 25.7702C31.7938 26.8889 30.2388 27.5173 28.6175 27.5173C26.9961 27.5173 25.4411 26.8889 24.2946 25.7702C23.1481 24.6515 22.504 23.1342 22.504 21.5521C22.504 19.9701 23.1481 18.4528 24.2946 17.3341C25.4411 16.2154 26.9961 15.5869 28.6175 15.5869ZM28.6175 18.4204C27.7662 18.4204 26.9499 18.7503 26.348 19.3377C25.7461 19.925 25.4079 20.7215 25.4079 21.5521C25.4079 22.3827 25.7461 23.1793 26.348 23.7666C26.9499 24.3539 27.7662 24.6839 28.6175 24.6839C29.4687 24.6839 30.2851 24.3539 30.887 23.7666C31.4889 23.1793 31.827 22.3827 31.827 21.5521C31.827 20.7215 31.4889 19.925 30.887 19.3377C30.2851 18.7503 29.4687 18.4204 28.6175 18.4204Z",
    fill: "#F2C94C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40263_68812",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40263_68812"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40263_68812",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/Pending.b98badf1d9c583bc13670c62ea2dc5c7.svg";
export { ForwardRef as ReactComponent };